<form [formGroup]="categoryForm">
    <fieldset>
        <div *ngIf="!categoryModel.isEdited" class="textContent">
            <div *ngFor="let textLine of displayCategoryTextLines">{{ textLine }}</div>
        </div>
        <pace-core-text-input
            [hidden]="!categoryModel.isEdited"
            [(model)]="displayCategoryText"
            id="categoryInputElement"
            #categoryInputElement
            (valueChange)="onValueChange($event)"
            [parentForm]="categoryFormChildren"
            [ariaLabel]="('INTERNAL_INFO_TEXT_AREA' | translate) + categoryType"
        ></pace-core-text-input>
    </fieldset>
    <p *ngIf="categoryModel.headerInfo" class="headerInfo">
        <strong>{{ lastEditedByLabel }} {{ categoryModel.headerInfo }}</strong>
    </p>
</form>
<div class="modal-footer justify-content-between justify-content-md-end">
    <button
        *ngIf="!categoryModel.isEdited"
        (click)="sortTextByDate()"
        class="btn btn-primary"
        translate="INTERNAL_INFO_SORT_BY_DATE_BUTTON_LABEL"
        [disabled]="formattedTextLines.length < 2"
        [ngClass]="{ sortText: reverse !== '', reverse: reverse }"
    ></button>
    <button
        (click)="onEdit()"
        *ngIf="!categoryModel.isEdited"
        class="btn btn-primary"
        translate="INTERNAL_INFO_EDIT_BUTTON_LABEL"
    ></button>
    <button
        (click)="onCancel()"
        *ngIf="categoryModel.isEdited"
        class="btn btn-primary"
        translate="INTERNAL_INFO_CANCEL_BUTTON_LABEL"
    ></button>
</div>
